// Types for streaming updates
export const UpdateActionType = {
    Created: 'Created',
    Updated: 'Updated',
    Deleted: 'Deleted',
} as const;
export type UpdateActionType = (typeof UpdateActionType)[keyof typeof UpdateActionType];
